import React, { useState } from 'react';
import { grey } from '@ant-design/colors';

interface Props {
	children: React.ReactNode;
	color: string;
	loadingColor?: string;
	onClick: () => Promise<void>;
}

export const AsyncLink: React.FC<Props> = ({ children, color, loadingColor = grey[5], onClick }: Props) => {
	const [loading, setLoading] = useState(false);

	const _onClick = async () => {
		if (loading) {
			return;
		}

		try {
			setLoading(true);
			await onClick();
		} finally {
			setLoading(false);
		}
	};

	return (
		<a onClick={_onClick} style={{ color: loading ? loadingColor : color, fontWeight: 500 }}>
			{children}
		</a>
	);
};
